import * as entity from '@common/domain/entities/RequisitionPartial'
import { IDetailComponent } from '@framework/components/mf-blade/mf-blade.component';
import * as GeneratedForms from "@framework/components/mf-generated-form/MfGeneratedFormExt"
import { IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { IApiServiceCommand } from '../../../services/api/api.service';
import * as app from '@framework/app';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { WorkflowType, ViewType } from '../../../framework/core/Enums';
import { PartialEmailsSelectorComponent } from '../../../modules/requisition/components/partial-emails-selector/partial-emails-selector.component';
import { ActionDialogComponent } from '../../../modules/shared/components/action-dialog/action-dialog.component';
import { Permissions } from '../../../config/AppEnums';
export class RequisitionPartialEndPoints extends entity.RequisitionPartialEndPoints {
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/detail/" + serviceCommand.context.entityId }, method: "GET" };
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/perRequisition/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartial/perRequisitionCount/" + serviceCommand.context.entityId }, method: "POST" };

}

export class RequisitionPartialBladeSetup {
  public onSaveEvent = function (prop) {
    //if (prop.listIndex == 0) {
    //  prop.parent.parent.getBladeByIndex(2).reloadFormByIndex(1);
    //}
  }

  public getPanelSubtitleFunc = function (context) {
    var form = context.getFormInstanceByIndex(0);
    if (!form || !context.getFormInstanceByIndex(0).entityData || !context.getFormInstanceByIndex(0).entityData.latestWorkflow || !context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow)
      return '';
    return 'Current Status: ' + context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow.name;
  }

  public onMenuActionOverlayClick = function (context) {
    context.loading = true;
    context.showActionDialog = false;

    if (context.overlayPanelData.text) {
      context.getFormInstanceByIndex(0).entityData.sivNumber = context.overlayPanelData.text;
      context.getFormInstanceByIndex(0).save(true);
      context.overlayIsSmallText = false;
    }
    else {
      context.apiService.post(`/api/requisitionPartial/createWorkflow/${context.overlayPanelIdentifier}/${context.entityId}`, { comments: context.overlayPanelData.comments })
        .subscribe(o => {
          context.loading = false;
          context.messageService.success('Saved successfully', 'Action');
          context.parent.getBladeByIndex(0).reloadFormByIndex(0);
          context.parent.getBladeByIndex(1).reloadFormByIndex(2);
          context.reloadFormByIndex(0);
          context.reloadFormByIndex(2);
          if (context.overlayPanelData && context.overlayPanelData.doNotCloseBlade) {

          }
          else context.closeBlade();
        }, err => {
          context.loading = false;
          context.messageService.danger('Could not save', 'Action');
        })
    }
  }

  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Add note", click: function (context) {
        context.overlayPanelData = { doNotCloseBlade: true };
        context.overlayPanelIdentifier = context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType;
        context.panelHeader = "Add note";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        return newItem
      }
    },
    {
      index: 1, displayName: "Send PO Emails", click: function (context) {
        const ref = context.dialogService.open(PartialEmailsSelectorComponent, {
          data: {
            requisitionPartialId: context.entityId
          },
          header: `Send PO supplier emails`,
          width: '50%'
        });
        ref.onClose.subscribe((emails) => {
          if (emails) {
            context.loading = true;
            context.apiService.post(`/api/requisitionPartial/sendPO/${context.entityId}`, { emails: emails })
              .subscribe(results => {
                context.loading = false;
                context.messageService.success("Emails have been sent", "Action");
              }, err => {
                  context.messageService.danger("Could not send emails", "Action");
                  context.loading = false;
              });
          }
        });
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        return false;
        return;
      }
    },
    {
      index: 1, displayName: "GRN", click: function (context) {
        context.overlayPanelData = { doNotCloseBlade: true };
        context.overlayPanelIdentifier = WorkflowType.WorkflowPartialItemGRND;
        context.panelHeader = "Override to GRN status";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex != 0)
          return;
        if (!context || !context.authService || !context.authService.userProfile)
          return;
        if (!context.entityData.latestWorkflow)
          return;

        if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowPartialItemPOGenerated) {
          if (context.authService.hasAnyPermissionsDeprecated(Permissions.ProcurementAdmin))
            return false;
        }
      }
    },
    //{
    //  index: 1, displayName: "Complete", click: function (context) {
    //    context.overlayPanelData = {};
    //    context.overlayPanelIdentifier = WorkflowType.WorkflowPartialComplete;
    //    context.panelHeader = "Complete";
    //    context.showActionDialog = true;
    //  },
    //  isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
    //    if (newItem)
    //      return true;
    //    if (formTriggerIndex == 0) {
    //      if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowPartialIssuedToWarehouse)
    //        return false;
    //      else return true
    //    }
    //    return;
    //  }
    //}
  ]
}

export class RequisitionPartialFormFields extends entity.RequisitionPartialFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      this.identifier.readOnly = true;
      //this.sisproIdentifier.formBuilderControl.controlType.viewType = ViewType.String;
      this.sisproIdentifier.viewType = ViewType.String;
      this.sisproIdentifier.readOnly = true;
      this.push(this.identifier);
      this.push(this.sisproIdentifier);

    } catch  { }
  }
}

export class RequisitionPartialForm extends entity.RequisitionPartialForm {
  protected requisitionPartialFormEndPoints: RequisitionPartialEndPoints = new RequisitionPartialEndPoints();
  protected requisitionPartialFormFields: RequisitionPartialFormFields = new RequisitionPartialFormFields();
}

export class RequisitionPartialListColumns extends entity.RequisitionPartialListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length)
      this.push(this.id);
     
      this.push(FormBuilderControlListHelper.getListColumn("latestRequisitionPartialWorkflow.datestamp", "Datestamp", null, null, "latestRequisitionPartialWorkflow_datestamp"));
      var format = FormBuilderControlListHelper.getListColumn("sisproIdentifierFormatted", "Test", null, null, "sisproIdentifierFormatted")
      format.visible = false;
      this.push(format);

      //this.push(this.sisproIdentifierFormatted);
 this.push(this.sisproIdentifierPrefix);
this.sisproIdentifierPrefix.visible = false;
this.sisproIdentifier.template = function(val, data){
return `${data.sisproIdentifierFormatted}`};
      this.push(this.sisproIdentifier);
     var supp = FormBuilderControlListHelper.getListColumn("requisitionItems", "Supplier", ViewType.String, null, "supplier");

      this.push(supp);
this.push(FormBuilderControlListHelper.getListColumn("latestRequisitionPartialWorkflow.workflow.name", "Workflow", null, null, "latestRequisitionPartialWorkflow_workflow_name"));
      var progress = FormBuilderControlListHelper.getListColumn("id", "Status Detail", ViewType.String, null, "workflowProgress");
      this.push(progress);
      var progress2 = FormBuilderControlListHelper.getListColumn("latestRequisitionPartialWorkflow.workflowId", "Status Detail", ViewType.String, null, "latestRequisitionPartialWorkflow_workflowId");
      progress2.visible = false;
      this.push(progress2);
      var progress3 = FormBuilderControlListHelper.getListColumn("requisitionItems", "Status Detail", ViewType.String, null, "requisitionItems");
      progress3.visible = false;
      this.push(progress3);
      
      this.push(this.identifier);
    } catch  { }
  }
}

export class RequisitionPartialList extends entity.RequisitionPartialList {
  protected requisitionPartialListEndPoints: RequisitionPartialEndPoints = new RequisitionPartialEndPoints();
  protected requisitionPartialListColumns: RequisitionPartialListColumns = new RequisitionPartialListColumns();
}
